import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { AuditAction, AuditComponent, enumMapper, EnumSortDirection, EnumValueType, FeatureFlag, HostAuditAction, HostAuditComponent, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { AuditService, buildODataQuery, FileDownloadService, ModalService, UserService, } from '@services';
import { BehaviorSubject, } from 'rxjs';
import { finalize, map, take, takeUntil, tap, } from 'rxjs/operators';
import { AuditLogDataModalComponent } from './modals';
// TODO: add a way to pass "OR" in filterValueMap in enumMapper()
var GridAuditService = /** @class */ (function (_super) {
    tslib_1.__extends(GridAuditService, _super);
    function GridAuditService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // map Component: `Folders` to `Folders OR Units`
    GridAuditService.prototype.get = function (queryOptions, endpoint) {
        if (queryOptions &&
            queryOptions.filter &&
            queryOptions.filter.and) {
            var component = queryOptions.filter.and.find(function (o) {
                var key = Object.keys(o)[0];
                return key === 'Component' && o[key].eq === 'Folders';
            });
            if (component != null) {
                delete component.Component;
                component['or'] = [
                    { 'Component': { eq: 'Folders' } },
                    { 'Component': { eq: 'Units' } },
                ];
            }
        }
        return _super.prototype.get.call(this, queryOptions, endpoint);
    };
    return GridAuditService;
}(AuditService));
export { GridAuditService };
var ɵ0 = urlStateHandler;
var AuditPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AuditPageComponent, _super);
    function AuditPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isUsersViewGranted$ = _this._appState.user.permissions.isGranted('Users.View');
        _this.loadingDetails$ = new BehaviorSubject(false);
        _this.userSuggest = _this._injector.get(UserService).suggest;
        _this.isHost = _this._appState.user.loggedInAsHost;
        _this._auditService = _this._service;
        _this._modalService = _this._injector.get(ModalService);
        _this._downloadService = _this._injector.get(FileDownloadService);
        return _this;
    }
    AuditPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.components = enumMapper(this._appState.user.loggedInAsHost ?
            HostAuditComponent :
            AuditComponent, {
            resourceKey: 'AuditComponent',
            type: EnumValueType.Key,
            sort: EnumSortDirection.ascending,
            filter: function (key) { return _this._filterAuditComponent(key); },
        });
        this.actions = enumMapper(this._appState.user.loggedInAsHost ?
            HostAuditAction :
            AuditAction, {
            resourceKey: 'AuditAction',
            type: EnumValueType.Key,
            sort: EnumSortDirection.ascending,
            filter: function (key) { return _this._filterAuditAction(key); },
        });
        this.reportsUrl$ = this._activeQuery$.pipe(map(function (qo) { return "" + _this._auditService.reportsUrl + buildODataQuery(qo); }));
        this._appState.language.change$
            .pipe(tap(function () { return _this._refresh$.next(); }), takeUntil(this._destroyed$))
            .subscribe();
    };
    AuditPageComponent.prototype.downloadReport = function (event) {
        var _this = this;
        event.preventDefault();
        this.reportsUrl$.pipe(take(1)).subscribe(function (url) {
            _this._downloadService.download(url);
        });
    };
    AuditPageComponent.prototype.showDetails = function (log) {
        var _this = this;
        this.loadingDetails$.next(true);
        this._auditService
            .getLogDetails(log)
            .pipe(finalize(function () { return _this.loadingDetails$.next(false); }), takeUntil(this._destroyed$))
            .subscribe(function (response) {
            var isDiffView = response.changes
                .some(function (change) { return change.isUpdate; });
            _this._modalService.openModal(AuditLogDataModalComponent, tslib_1.__assign({}, response, { log: log }), {
                size: isDiffView ?
                    'lg' :
                    undefined,
            });
        });
    };
    AuditPageComponent.prototype._filterAuditComponent = function (key) {
        if (!isNaN(Number.parseInt(key, 10))) {
            return false;
        }
        switch (key) {
            case 'Tasks':
            case 'TaskCatalogs':
                return this._appState.settings.isFeatureEnabled(FeatureFlag.Tasks);
            case 'Maintenance':
                return this._appState.settings.isFeatureEnabled(FeatureFlag.Maintenance);
            default:
                return true;
        }
    };
    AuditPageComponent.prototype._filterAuditAction = function (key) {
        if (!isNaN(Number.parseInt(key, 10))) {
            return false;
        }
        switch (key) {
            case 'Assign':
            case 'Unassign':
                return this._appState.settings.isFeatureEnabled(FeatureFlag.Tasks);
            case 'Start':
            case 'End':
            case 'Skip':
                return this._appState.settings.isFeatureEnabled(FeatureFlag.Maintenance);
            default:
                return true;
        }
    };
    return AuditPageComponent;
}(ODataGridComponent));
export { AuditPageComponent };
export { ɵ0 };
